module.exports = __webpack_public_path__ + "static/assets/2159f1b0b45899bce155fa25debfa225.svg";